var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdaptiveLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 41.9999V47.9999H38V41.9999C38 38.6919 35.308 35.9999 32 35.9999H16C12.692 35.9999 9.99996 38.6919 9.99996 41.9999V47.9999H7.99996V41.9999C7.99996 37.5879 11.588 33.9999 16 33.9999H32C36.412 33.9999 40 37.5879 40 41.9999ZM44 8.99987V23.9999H42V9.96787L36 12.9519V17.9999C36 24.6179 30.618 29.9999 24 29.9999C17.382 29.9999 12 24.6179 12 17.9999V12.9519L4.05396 8.99987L20.622 0.757872C22.638 -0.244128 25.352 -0.246128 27.374 0.755872L43.944 8.99987H44ZM34 13.9459L27.376 17.2399C26.366 17.7419 25.182 17.9939 24 17.9939C22.818 17.9939 21.632 17.7439 20.624 17.2399L14 13.9459V17.9979C14 23.5119 18.486 27.9979 24 27.9979C29.514 27.9979 34 23.5119 34 17.9979V13.9459ZM39.456 8.99987L26.488 2.54787C25.022 1.82387 22.976 1.82187 21.514 2.54787L8.54595 8.99787L21.514 15.4499C22.978 16.1779 25.022 16.1779 26.486 15.4499L39.456 8.99987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaptiveLearning);
export default __webpack_public_path__ + "static/media/adaptiveLearning.ac8e7579f704586c84e00559fc9c3cc6.svg";
export { ForwardRef as ReactComponent };